import {HttpClient} from "../../service/httpClient/HttpClient";


export class UsersAvatarService {

    constructor() {
        this.httpClient = new HttpClient()
    }

    getUsersAvatarList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `predefined-avatars`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewPredefinedAvatar(title, slug) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `predefined-avatars`,
                {
                    title,
                    slug
                }
            ).then(resolve).catch(reject)
        })

    }

    getPredefinedAvatarBasicInfo(avatarId, title, slug) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `predefined-avatars/${avatarId}/information`,
                {
                    title,
                    slug
                }
            ).then(resolve).catch(reject)
        })
    }

    updatePredefinedAvatarBasicInfo(avatarId, title, slug) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `predefined-avatars/${avatarId}/information`,
                {
                    "title": title,
                    "slug": slug
                }
            ).then(resolve).catch(reject)
        })
    }

    getPredefinedAvatarStatus(avatarId, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `predefined-avatars/${avatarId}/enabled`,
                {
                    "enabled": enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    updatePredefinedAvatarStatus(avatarId, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `predefined-avatars/${avatarId}/enabled`,
                {},
                {
                    "enabled": enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    getPredefinedAvatar(avatarId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `predefined-avatars/${avatarId}/images`
            ).then(resolve).catch(reject)
        })
    }

    updatePredefinedAvatar(avatarId,avatarImageId) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `predefined-avatars/${avatarId}/images`,
                {},
                {
                    "id":avatarImageId
                }
            ).then(resolve).catch(reject)
        })

    }

}